import { StoreAction } from '../eventTypes/storeActions';
import { MESSAGE_EVENTS } from '@sa/cassius-contract';

/**
 * Dispatch messages from the app as actions on the given store.
 * @param event the app message event.
 * @param store the botframework webchat redux store.
 */
export function handleAppMessageEvent(event: MessageEvent, store) {
  if (MESSAGE_EVENTS.includes(event.data?.type)) {
    store.dispatch({
      type: 'DHS/RECEIVE_APP_MESSAGE',
      payload: { type: event.data.type, data: event.data }
    } as StoreAction);
  }
}
